module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.toApplyStep(order)
        }
      }
    }, [_c('div', {
      staticClass: "justify-space-flex row-title"
    }, [_c('div', {
      staticClass: "title-left flex-start gray"
    }, [_c('img', {
      staticClass: "row-title-img",
      attrs: {
        "src": "https://static.dierqudao.com/images/dinghuoxitong/icon-date.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("timeFormat")(order.create_time)) + " 申报")])]), _vm._v(" "), (order.memberstatus === 1) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("联系人信息")]) : (order.memberstatus === 2) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("人员等级")]) : (order.memberstatus === 3) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("食宿信息")]) : (order.memberstatus === 4) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("确认订单")]) : (order.memberstatus === 6) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("申报成功")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "justify-space-flex row-goods"
    }, [_c('div', {
      staticClass: "row-left flex-start"
    }, [_c('div', {
      staticClass: "goods-detail"
    }, [_c('div', {
      staticClass: "goods-name"
    }, [_vm._v("\n                  " + _vm._s(order.danwei) + "\n                  "), _c('div', [_vm._v(_vm._s(order.num))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(order.saiqu_name))]), _vm._v(" "), _c('div', [_vm._v("人数:" + _vm._s(order.member_count))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-weight gray-light"
    }, [_vm._v("\n                  联系人:" + _vm._s(order.ldname) + " 电话:" + _vm._s(order.phone) + "\n                ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "row-btn"
    }, [(order.memberstatus >= 1 && order.memberstatus <= 4) ? _c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          return _vm.toApplyStep(order)
        }
      }
    }, [_vm._v("继续申报\n            ")]) : _vm._e(), _vm._v(" "), (order.memberstatus === 6) ? _c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          return _vm.toApplyStep(order)
        }
      }
    }, [_vm._v("查看详情\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          return _vm.toMember(order)
        }
      }
    }, [_vm._v(_vm._s(order.memberstatus == 6 ? '查看人员' : '完善人员'))])])])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.toCert
    }
  }, [_vm._v("运动员备案\n      ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.toApply
    }
  }, [_vm._v("能力测试申报\n      ")])], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51d938e7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/skill/AbilityApplyList.vue
// module id = 2395
// module chunks = 0